import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import FindFlight from './Flights/FindFlight';
import AuthContext from 'store/AuthContext';
import UploadFile from './Upload/UploadFile';

import './homePage.css';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        minHeight: 'fit-content',
        height: '480px'
    },
    form: {
        height: '100%',
    },
}));

function HomePage(props) {
    const { userInfo } = useContext(AuthContext);
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <Paper className={classes.form}>
                        <UploadFile  showBackBtn={false}  showFileList={false} uploadIconSize="100px"/>
                    </Paper>
                </Grid>
                <Grid item xs={6}>
                    <Paper className={classes.form}>
                        <FindFlight airlineCode={userInfo.airlineCode} props={props} />
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

export default HomePage;